import { useRef, useEffect } from 'react';
export function useDeviationChangedCallback(deviation, callback) {
    var previousDeviationId = useRef();
    var currentDeviationId = deviation && deviation.deviationId;
    useEffect(function () {
        if (deviation && currentDeviationId !== previousDeviationId.current) {
            callback(deviation);
        }
        previousDeviationId.current = currentDeviationId;
    }, [currentDeviationId, callback, deviation]);
}
//# sourceMappingURL=useDeviationChangedCallback.js.map